import { useEffect, useState } from 'react'
import { fetchLot } from '../api.js'

// Hook de detalle de un lote.
// Devuelve: { lot, loading, error, refetch }
export function useLot(id) {
  const [lot, setLot] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let active = true
    setLoading(true)
    setError(null)
    fetchLot(id)
      .then((res) => { if (active) setLot(res.data) })
      .catch((e) => { if (active) setError(e.message || 'Fehler beim Laden') })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [id])

  return { lot, loading, error }
}
